import { render } from "./VideoContainer.vue?vue&type=template&id=4f991a88"
import script from "./VideoContainer.vue?vue&type=script&lang=js"
export * from "./VideoContainer.vue?vue&type=script&lang=js"

import "./VideoContainer.vue?vue&type=style&index=0&id=4f991a88&lang=css"
script.render = render

export default script